import React, { useState } from 'react';

import styled from 'styled-components';

import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';

import { articlePropType } from 'helpers/customPropTypes';

import colors from 'theme/colors';
import media from 'theme/media';

import { LightFlagIcon } from '../common/fromAuth/LightFlagIcon/LightFlagIcon';
import { LightText } from '../common/fromAuth/LightText/LightText';
import { PromoDangerouslyHtml } from '../common/promo-dangerously-html/PromoDangerouslyHtml';

const CSS_COLLAPSED = 'collapsed';
const Value = styled.div``;
const IconWrapper = styled.span`
    height: 24px;
    overflow: hidden;
    margin-left: 16px;
    min-width: 24px;
    transition-duration: 0.4s;
    transition-property: transform;
    width: 24px;
`;
const FlagWrapper = styled.span`
    height: 24px;
    overflow: hidden;
    margin-right: 24px;
    min-width: 24px;
    width: 24px;

    ${media.tablet648} {
        margin-top: 4px;
    }
`;
const FlexWrapper = styled.h3`
    display: flex;
    font-weight: normal;
    flex-grow: 1;
    justify-content: space-between;
`;
const AccordeonHeader = styled.a`
    cursor: pointer;
    display: flex;
    padding: 30px 0 2px;

    &:focus-visible {
        background-color: ${colors.superLightGray};
        outline: 1px dashed ${colors.lightGray};
    }

    &:hover {
        ${Value} {
            color: ${colors.purple};
        }

        ${IconWrapper} {
            use {
                --accent: ${colors.purple};
            }
        }
    }

    &.collapsed {
        ${IconWrapper} {
            transform: rotate(180deg);
        }
    }

    ${media.tablet648} {
        padding: 40px 0 8px;
    }
`;
const AccordeonContent = styled.div`
    margin-bottom: 24px;
    margin-top: 24px;
    max-width: 592px;
`;
const Accordeon = (props) => {
    const [isOpen, setOpen] = useState(false);
    const clickHandler = (e) => {
        e.preventDefault();
        setOpen(!isOpen);
    };
    return (
        <li>
            <AccordeonHeader className={isOpen ? CSS_COLLAPSED : ''} onClick={clickHandler} onKeyPress={clickHandler} tabIndex={'0'}>
                {props.addIcon ? (
                    <FlagWrapper>
                        <LightFlagIcon name={props.addIcon} size={'24px'} />
                    </FlagWrapper>
                ) : null}
                <FlexWrapper>
                    <Value>
                        <LightText variant={'span'}>{props.title}</LightText>
                    </Value>
                    <IconWrapper>
                        <PromoIcon name={'chevron-down'} color={'baseColor'} size={'24px'} />
                    </IconWrapper>
                </FlexWrapper>
            </AccordeonHeader>
            {isOpen && (
                <AccordeonContent>
                    <PromoDangerouslyHtml color={`${props.addIcon ? 'baseColor' : 'gray80'}`} dangerouslyHtml={props.text} variant={'subheader'} tag={'div'} />
                    {props.picture ? props.picture : null}
                    {props.link ? props.link : null}
                </AccordeonContent>
            )}
        </li>
    );
};

Accordeon.propTypes = articlePropType.isRequired;
export default Accordeon;
